import { IAddressDto } from "./address.model";

export class Client implements IClient {
  restaurantId: number;
  clientId: string;
  outlet: IClientOutlet;
  location: IAddressDto;
  color: string;
  webUrl: string;
  title: string;
  currency: string;
  style: any;
  active?: boolean;

  constructor(json: IClient) {
    Object.assign(this, json);
  }
}

export interface IClient {
  restaurantId: number;
  clientId: string;
  outlet: IClientOutlet;
  location: IAddressDto;
  color: string;
  webUrl: string;
  title: string;
  currency: string;
  style: any;
  active?: boolean;
  isLocation?: boolean;
}

export interface IClientOutlet {
  id?: number;
  name?: string;
  deliveryType?: number;
  minAmount?: number;
  time?: string;
  scheduleOrder?: boolean;
  miles?: number;
  isOrderingServices?: boolean;
}
